import { ErrorMessage, Field } from "formik";
import { TbStarFilled, TbStar } from "react-icons/tb";

const FormPollField = ({ name, label, type = "text", ...rest }) => {
	const options = [
		{ value: "1", label: "Muy insatisfecho" },
		{ value: "2", label: "Insatisfecho" },
		{ value: "3", label: "Neutral" },
		{ value: "4", label: "Satisfecho" },
		{ value: "5", label: "Muy satisfecho" },
	];

	return (
		<div className="w-full relative mb-8">
			<label
				htmlFor={name}
				className="flex items-center mt-3 gap-4 w-full md:max-w-xl mx-auto text-gray-700 text-base md:text-lg font-semibold mb-2 "
			>
				{label}
			</label>

			{type === "radio" ? (
				<Field name={name} {...rest}>
					{({ field }) => {
						const selectedValue = parseInt(field.value, 10);

						return (
							<div className="flex h-auto justify-between items-streched mt-3 gap-2 md:gap-4 w-full md:max-w-xl mx-auto">
								{options.map((option) => {
									const optionValue = parseInt(option.value, 10);
									const isSelected = field.value === option.value;
									const isFilled = optionValue <= selectedValue;

									return (
										<label
											key={option.value}
											htmlFor={`${name}_${option.value}`}
											className="h-auto cursor-pointer flex flex-col justify-between items-center flex-1"
										>
											<input
												type="radio"
												id={`${name}_${option.value}`}
												name={name}
												value={option.value}
												className="hidden"
												checked={isSelected}
												onChange={field.onChange}
											/>

											<div
												className={`text-4xl mb-1 transition-colors duration-200 ${
													isFilled ? "text-red-600" : "text-gray-300"
												}`}
											>
												{isFilled ? <TbStarFilled /> : <TbStar />}
											</div>

											<span
												className={`text-[10px] md:text-sm text-center transition-all ${
													isSelected
														? "text-red-600 font-bold"
														: "text-gray-500"
												}`}
											>
												{option.label}
											</span>
										</label>
									);
								})}
							</div>
						);
					}}
				</Field>
			) : (
				<div className="flex items-center justify-center">
					<Field
						as="textarea"
						type={type}
						name={name}
						id={name}
						rows={2}
						className="w-11/12 p-2 border border-gray-300 focus:border-red-600 rounded-lg text-black resize-none"
						{...rest}
					/>
				</div>
			)}

			<ErrorMessage name={name}>
				{(message) => (
					<div className="text-center text-sm text-red-500 text-bold">
						{message}
					</div>
				)}
			</ErrorMessage>
		</div>
	);
};

export default FormPollField;
